import { Activity, Database, Server } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import type { ProcessingPipelineState } from '@/services/api/adminProcessing'
import { HealthTile } from './HealthTile'

export function HealthCard({ pipeline }: { pipeline: ProcessingPipelineState }) {
  const { t } = useTranslation()
  const h = pipeline.health
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">{t('admin.processing.health.title')}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          <HealthTile
            icon={<Server className="h-4 w-4" />}
            label={t('admin.processing.health.workers')}
            value={String(h.workers)}
            ok={h.workers > 0}
          />
          <HealthTile
            icon={<Activity className="h-4 w-4" />}
            label={t('admin.processing.health.rabbitmq')}
            value={
              h.rabbit_ok
                ? t('admin.processing.health.reachable')
                : t('admin.processing.health.down')
            }
            ok={h.rabbit_ok}
          />
          <HealthTile
            icon={<Database className="h-4 w-4" />}
            label={t('admin.processing.health.database')}
            value={
              h.db_ok ? t('admin.processing.health.reachable') : t('admin.processing.health.down')
            }
            ok={h.db_ok}
          />
          <HealthTile
            icon={<Activity className="h-4 w-4" />}
            label={t('admin.processing.health.queue')}
            value={h.queue}
            ok={true}
          />
        </div>
      </CardContent>
    </Card>
  )
}
